import Glide from '@glidejs/glide';

class glideLoader {
    constructor() {
        this.initSettings();
        document.addEventListener('DOMContentLoaded', () => {
            Array.from(document.querySelectorAll('[data-glide]')).forEach((el) => {
                try {
                    const settings = this.getTypeSettings(el.dataset.glideType);
                    var slider = new Glide(el, settings);
                    slider.mount();
                } catch (e) { console.error('Error', e); }
            });
        });
    }

    initSettings() {
        
    }

    getTypeSettings(type) {
        const settings = {
            blog: {
                type: 'slider',
                startAt: 0,
                perView: 1,
                gap: (16 * 4),
                peek: (window.innerWidth * .30),
                // autoplay: 4000,
                hoverPause: true,
                breakpoints: {
                    992: {
                        peek: (window.innerWidth * .15),
                    },
                    768: {
                        peek: (16 * 4),
                        gap: (16 * 4)
                    },
                    500: {
                        peek: (16),
                        gap: (16 * 2),
                        autoplay: 7500
                    }
                }
            },
            side_by_side: {
                type: 'slider',
                startAt: 0,
                perView: 1,
            },
            testimonial: {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                // gap: (16 * 4),
                // peek: (window.innerWidth * .30),
                autoplay: 5000,
                hoverPause: true,
                // breakpoints: {
                //     992: {
                //         peek: (window.innerWidth * .15)
                //     }
                // }
            }
        };
        return settings[type];
    }
}
new glideLoader();